import { useState } from "react";
import TopMenu from "../TopMenu/TopMenu";
import SideMenu from "../SideMenu/SideMenu";
import { Outlet } from "react-router-dom";

const MainLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="dark:bg-boxdark-2 dark:text-bodydark">
      <div className="flex h-screen overflow-hidden">
        <SideMenu sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
          <TopMenu sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
          <main className={`h-full bg-[#F3F5F9] ${sidebarOpen ? "overflow-hidden" : "overflow-auto"}`}>
            <div className="mx-auto max-w-full p-3">
              <Outlet />
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
